<template>
	<c-dialog ref="dialog" mode="slide" width="50vw" :button="false">
		<div class="m-log-content">
			<div v-if="productInfo" class="m-log-head">{{productInfo}}</div>
			<c-title>借出记录</c-title>
			<c-table ref="list" border :paging="false">
				<c-table-column label="借货人" name="borrower_name" width="70"></c-table-column>
				<c-table-column label="同行价" width="100">
					<template #default="{data}">
						<span style="color: #e53e3e;">{{formatPrice(data.market_price)}}</span>
					</template>
				</c-table-column>
				<c-table-column label="借出时间" name="lend_date" width="120"></c-table-column>
				<c-table-column label="归还时间" name="return_date" width="120"></c-table-column>
				<c-table-column label="借出时长" width="80">
					<template #default="{data}">
						{{data.lend_days !== null && data.lend_days !== undefined ? data.lend_days + '天' : '-'}}
					</template>
				</c-table-column>
				<c-table-column label="状态" width="70">
					<template #default="{data}">
						<c-state dict="saleReturnStateDic" :value="data.return_state"></c-state>
					</template>
				</c-table-column>
				<c-table-column label="操作人" name="operator_name" width="70"></c-table-column>
			</c-table>
		</div>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'saleLendLog',

		computed: {
			...mapState(['saleReturnStateDic'])
		},

		data() {
			return {
				productInfo: ''
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data) {
				this.productInfo = data.product_info || data.produce_unique_code || '';
				this.$refs.dialog.open({title: '借出记录'});
				this.$nextTick(() => {
					this.$refs.list.load({
						url: '/sale/lend/listByProduct',
						data: {
							product_id: data.id
						}
					});
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-log-content {
		padding: 20px;
	}

	.m-log-head {
		padding: 10px 0 16px;
		font-size: 18px;
		font-weight: 600;
		color: #333;
		text-align: center;
	}
</style>
